import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaUserCircle } from 'react-icons/fa'; // icon avatar

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function ProfilePage({ user }) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState([]);
  const [history, setHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const [periodeStart, setPeriodeStart] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [periodeEnd, setPeriodeEnd] = useState(new Date());
  const [statusFilter, setStatusFilter] = useState('ALL');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {

    fetchPlan();

  }, []);

  useEffect(() => {
    if (user.role === 'USER') {
      fetchHistory();
    }
  }, [periodeStart, periodeEnd, statusFilter, page]);
  const fetchHistory = async () => {
    setLoadingHistory(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/user/order-history`, {
        periode_start: periodeStart.toISOString().split('T')[0],
        periode_end: periodeEnd.toISOString().split('T')[0],
        status: statusFilter,
        page,
        limit: 10
      }, {
        withCredentials: true,
      });
      setHistory(res.data.data || []);
      setTotalPages(res.data.totalPages);
    } catch (err) {
      Swal.fire('Oops!', err.response?.data?.message || "Silakan coba lagi.", 'error');
    } finally {
      setLoadingHistory(false);
    }
  };

  const fetchPlan = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/current-plan`, {
        withCredentials: true,
      });
      setPlan(res.data.data || []);
    } catch (err) {
      Swal.fire('Oops!', (err.response?.data?.message || "Silakan coba lagi."), 'error');
    } finally {
      setLoading(false);
    }
  };

  const refreshPlan = async () => {
    await fetchPlan();
  }

  const handleChangePassword = async () => {
    if (!password || !confirmPassword) {
      return Swal.fire('Oops!', 'Mohon isi kedua kolom password.', 'error');
    }

    if (password !== confirmPassword) {
      return Swal.fire('Oops!', 'Password dan konfirmasi tidak cocok.', 'error');
    }

    setLoading(true);
    try {
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + '/profile/change-password',
        {
          userId: user.id,
          newpassword: password,
        },
        { withCredentials: true }
      );

      Swal.fire('Berhasil', 'Password berhasil diubah.', 'success');
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      Swal.fire('Oops!', err.response?.data?.error || 'Terjadi kesalahan.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid px-0">
      <h3>My Profile</h3>

      <div className='row'>

        <div className='col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 mt-4'>

          <div className="card shadow-sm p-4">
            <div className="text-center">
              {user.photo_url ? (
                <img
                  src={user.photo_url}
                  alt="User Profile"
                  className="rounded-circle"
                  style={{ width: 100, height: 100, objectFit: 'cover' }}
                  referrerPolicy="no-referrer"
                />
              ) : (
                <FaUserCircle size={100} className="text-dark" />
              )}
              <h5 className="mt-2">{user.name}</h5>
              <p className="text-muted">{user.email}</p>
            </div>

            {user.role === 'ADMIN' && (
              <>
                <hr />
                <h6>Ubah Password</h6>
                <div className="mb-3">
                  <label className="form-label">Password Baru</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Konfirmasi Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    disabled={loading}
                  />
                </div>
                <button
                  className="btn btn-dark w-100"
                  onClick={handleChangePassword}
                  disabled={loading}
                >
                  {loading ? 'Memuat...' : 'Simpan'}
                </button>
              </>
            )}
          </div>

          {
            user.role == 'USER' && (
              <div className='card shadow-sm mt-4'>

                <div className='card-body w-100 p-3'>

                  <div className='row align-items-center mb-1'>
                    <div className='col-12'>
                      <small className='text-muted' style={{ fontSize: '11px' }}>Current Plan</small>
                      <h2 className='text-dark fw-bold mb-1' style={{ fontSize: '2rem' }}>{plan.current_plan ?? '-'}</h2>

                      {plan.has_package == 1 && (
                        <>
                          <small className='text-dark'>Valid Until: <b>
                            {
                              plan.duration_type == 'Permanent' ? 'Permanent' : new Date(plan.valid_until).toLocaleDateString('id-ID', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                              })
                            }
                          </b></small>
                          <br /><br />
                        </>
                      )}
                    </div>
                    {/* <div className='col-3 text-end'>
                        <a className='text-dark' style={{cursor: 'pointer', textDecoration: 'none'}} href='javascript:void(0);' onClick={refreshPlan}>
                          <i className='fa fa-refresh' style={{ fontSize: '1.5rem' }}></i>
                        </a>
                      </div> */}
                  </div>

                  <div className='row align-items-center'>
                    <div className='col-9'>
                      <label className='text-muted' style={{ fontSize: '9px' }}>Session Created / Max. Sessions</label>
                    </div>
                    <div className='col-3 text-end fw-bold'>
                      <label className='text-dark' style={{ fontSize: '9px' }}>{plan.user_session ?? '-'}/{(plan.max_session ?? '-') == '-1' ? 'Unlimited' : plan.max_session}</label>
                    </div>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-9'>
                      <label className='text-muted' style={{ fontSize: '9px' }}>Chat Attempt Used / Max. Attempts</label>
                    </div>
                    <div className='col-3 text-end fw-bold'>
                      <label className='text-dark' style={{ fontSize: '9px' }}>{plan.user_attempt ?? '-'}/{(plan.max_attempt ?? '-') == '-1' ? 'Unlimited' : plan.max_attempt}</label>
                    </div>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-9'>
                      <label className='text-muted' style={{ fontSize: '9px' }}>Max. Generate AI Token</label>
                    </div>
                    <div className='col-3 text-end fw-bold'>
                      <label className='text-dark' style={{ fontSize: '9px' }}>{plan.max_ai_token ?? '-'}</label>
                    </div>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-9'>
                      <label className='text-muted' style={{ fontSize: '9px' }}>Voice to Voice AI Feature</label>
                    </div>
                    <div className='col-3 text-end fw-bold'>
                      <label className='text-dark' style={{ fontSize: '9px' }}>{(plan.is_ai_audio_active ?? 0) == 1 ? 'ACTIVE' : 'INACTIVE'}</label>
                    </div>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-9'>
                      <label className='text-muted' style={{ fontSize: '9px' }}>Voice Attempt Used / Max. Attempts</label>
                    </div>
                    <div className='col-3 text-end fw-bold'>
                      <label className='text-dark' style={{ fontSize: '9px' }}>{plan.user_voice_attempt ?? '-'}/{(plan.max_voice_attempt ?? '-') == '-1' ? 'Unlimited' : plan.max_voice_attempt}</label>
                    </div>
                  </div>
                  <div className='row align-items-center'>
                    <div className='col-9'>
                      <label className='text-muted' style={{ fontSize: '9px' }}>Examination Assistant Attempt Used / Max. Attempts</label>
                    </div>
                    <div className='col-3 text-end fw-bold'>
                      <label className='text-dark' style={{ fontSize: '9px' }}>{plan.attempt_exam_assist ?? '-'}/{(plan.max_exam_assist ?? '-') == '-1' ? 'Unlimited' : plan.max_exam_assist}</label>
                    </div>
                  </div>


                </div>

              </div>
            )
          }

        </div>

        <div className='col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12 mt-4'>

          {
            user.role == 'USER' && (
              <div className='card shadow-sm border-0'>

                <div className='card-header bg-white py-3 border-bottom'><h5 className='mb-0 fw-bold'><i className='fa fa-history me-2'></i> Riwayat Pesanan</h5></div>
                <div className='card-body w-100'>

                  <div className='mb-3 d-flex flex-wrap gap-2'>
                    <DatePicker
                      selected={periodeStart}
                      onChange={(date) => setPeriodeStart(date)}
                      selectsStart
                      startDate={periodeStart}
                      endDate={periodeEnd}
                      className='form-control'
                      placeholderText='Periode Awal'
                    />
                    <DatePicker
                      selected={periodeEnd}
                      onChange={(date) => setPeriodeEnd(date)}
                      selectsEnd
                      startDate={periodeStart}
                      endDate={periodeEnd}
                      className='form-control'
                      placeholderText='Periode Akhir'
                    />
                    <select className='form-select' value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                      <option value='ALL'>Semua Status</option>
                      <option value='PENDING'>Pending</option>
                      <option value='SETTLEMENT'>Settlement</option>
                      <option value='CANCEL'>Cancel</option>
                    </select>
                  </div>

                  <div className='table-responsive'>
                    <table className='table table-bordered table-hover table-striped'>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Transaction ID</th>
                          <th>Tanggal Transaksi</th>
                          <th>Valid Until</th>
                          <th>Status Pembayaran</th>
                          <th>Nama Paket</th>
                          <th>Total</th>
                          <th>Status</th>
                          <th>Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingHistory ? (
                          <tr><td colSpan="9" className='text-center'>Memuat...</td></tr>
                        ) : history.length === 0 ? (
                          <tr><td colSpan="9" className='text-center'>Tidak ada data</td></tr>
                        ) : (
                          history.map((item, index) => (
                            <tr key={item.id}>
                              <td>{(page - 1) * 10 + index + 1}</td>
                              <td><b className='fw-bold text-dark'>{item.transaction_id}</b></td>
                              <td>{new Date(item.transaction_date).toLocaleDateString('id-ID', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: false
                              })}</td>
                              <td>
                                {
                                  item.price_duration_type == "Permanent" ? 'Permanent' : item.valid_until && (
                                    <>
                                      {new Date(item.valid_until).toLocaleDateString('id-ID', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                      })}
                                    </>
                                  )
                                }
                              </td>
                              <td><b className={item.transaction_status == 'PENDING' ? 'text-warning' : (item.transaction_status == 'SETTLEMENT' ? 'text-success' : 'text-danger')}>{item.transaction_status}</b></td>
                              <td>{item.price_name}</td>
                              <td>Rp {parseInt(item.price_total).toLocaleString('id-ID')}</td>
                              <td><b className={item.status == 'ACTIVE' ? 'text-success' : 'text-danger'}>{item.status}</b></td>
                              <td>
                                <button className='btn btn-sm btn-dark' onClick={() => {
                                  setSelectedOrder(item);
                                  setShowModal(true);
                                }}>
                                  Detail <i className='fa fa-arrow-right'></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className='d-flex justify-content-between align-items-center'>
                    <button
                      className='btn btn-outline-secondary btn-sm'
                      disabled={page === 1}
                      onClick={() => setPage(page - 1)}
                    >
                      Sebelumnya
                    </button>
                    <span className='text-center'>Halaman {page} dari {totalPages}</span>
                    <button
                      className='btn btn-outline-secondary btn-sm'
                      disabled={page === totalPages}
                      onClick={() => setPage(page + 1)}
                    >
                      Selanjutnya
                    </button>
                  </div>

                </div>

              </div>
            )
          }

        </div>

      </div>

      {showModal && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Detail Transaksi</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body row g-2">

                <div className="col-12 mb-3 text-center">
                  <h4 className="fw-bold">{selectedOrder.transaction_id}</h4>
                  <span className={`badge bg-${selectedOrder.transaction_status === 'SETTLEMENT' ? 'success' : selectedOrder.transaction_status === 'PENDING' ? 'warning text-dark' : 'danger'}`}>
                    {selectedOrder.transaction_status}
                  </span>
                </div>

                <div className="col-md-6">
                  <strong>Tanggal Transaksi:</strong><br />
                  {new Date(selectedOrder.transaction_date).toLocaleString('id-ID', {
                    day: '2-digit', month: 'short', year: 'numeric',
                    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
                  })}
                </div>

                <div className="col-md-6">
                  <strong>Tanggal Pembayaran:</strong><br />
                  {
                    selectedOrder.payment_date && (
                      <>
                        {new Date(selectedOrder.payment_date).toLocaleDateString('id-ID', {
                          day: '2-digit', month: 'short', year: 'numeric',
                          hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
                        })}
                      </>
                    )
                  }

                </div>

                <div className="col-md-6">
                  <strong>Berlaku Hingga:</strong><br />
                  {selectedOrder.valid_until
                    ? new Date(selectedOrder.valid_until).toLocaleString('id-ID', {
                      day: '2-digit', month: 'short', year: 'numeric',
                      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
                    })
                    : '-'}
                </div>

                <div className="col-md-6">
                  <strong>Status:</strong><br />
                  <span className={`badge bg-${selectedOrder.status === 'ACTIVE' ? 'success' : 'danger'}`}>
                    {selectedOrder.status}
                  </span>
                </div>

                <hr className="my-3" />

                <div className="col-12">
                  <h5>Detail Paket</h5>
                </div>

                <div className="col-md-6"><strong>Kode Paket:</strong><br />{selectedOrder.price_code}</div>
                <div className="col-md-6"><strong>Nama Paket:</strong><br />{selectedOrder.price_name}</div>
                <div className="col-md-6"><strong>Durasi:</strong><br />{selectedOrder.price_duration_value} {selectedOrder.price_duration_type}(s)</div>
                <div className="col-md-6"><strong>Max. Sesi:</strong><br />{selectedOrder.price_max_session === -1 ? 'Unlimited' : selectedOrder.price_max_session}</div>
                <div className="col-md-6"><strong>Max. Chat Attempts:</strong><br />{selectedOrder.price_max_attempt === -1 ? 'Unlimited' : selectedOrder.price_max_attempt}</div>
                <div className="col-md-6"><strong>Voice AI Aktif:</strong><br />
                  <span className={`text-${selectedOrder.price_is_ai_audio_active === 1 ? 'success' : 'danger'}`}>
                    {selectedOrder.price_is_ai_audio_active === 1 ? 'YES' : 'NO'}
                  </span>
                </div>
                <div className="col-md-6"><strong>Max. Voice Attempts:</strong><br />{selectedOrder.price_max_voice_attempt === -1 ? 'Unlimited' : selectedOrder.price_max_voice_attempt}</div>
                <div className="col-md-6"><strong>Max. Examination Assistant Attempts:</strong><br />{selectedOrder.price_examination_assist_max === -1 ? 'Unlimited' : selectedOrder.price_examination_assist_max}</div>
                <div className="col-md-6"><strong>Total Harga:</strong><br /><b>Rp. {selectedOrder.price_total.toLocaleString('id-ID')}</b></div>

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Tutup</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );

}

export default ProfilePage;
